import type { SpaceTargetKind } from './space-node-kind';
import type { SpaceTreeScope } from './space-tree-scope';

export const spaceTreeQueryKeys = {
  all: ['space-tree'] as const,
  children: (orgId: string, parentId: string | null) =>
    [...spaceTreeQueryKeys.all, 'children', orgId, parentId ?? 'root'] as const,
  subtree: (
    orgId: string,
    rootId: string,
    leafTargetKind?: SpaceTargetKind,
    scope?: SpaceTreeScope
  ) =>
    [
      ...spaceTreeQueryKeys.all,
      'subtree',
      orgId,
      rootId,
      ...(leafTargetKind !== undefined ? [leafTargetKind] : []),
      ...(scope !== undefined ? [scope] : []),
    ] as const,
  archivedTemplate: (orgId: string) =>
    [...spaceTreeQueryKeys.all, 'archived-template', orgId] as const,
};
